import "./styles.scss";

import { CircularProgress, Divider } from "@mui/material";
import { EditRounded, DownloadRounded, ArrowBackIosRounded, FullscreenRounded, FullscreenExitRounded } from "@mui/icons-material";

import { Button, Text } from '@fragments'
import { useEffect } from 'react';
import { useScreen } from 'Screen/ScreenContext';
import CommunityPlansAvailableTable from "@components/CommunityPlansAvailableTable";
import ManageMaterialModal from "@modals/Material/ManageMaterial";

import PDFSidebar from "./components/PDFSidebar";
import PDFRender from "./components/PDFRender";

export default function MaterialView({
    material,
    loading,
    zoom,
    pdfDocument,
    currentPage,
    setCurrentPage,
    currentCommunity,
    isFullscreen,
    REF_materialModal,
    fullscreenRef,
    handleDownload,
    handleOpenEditMaterial,
    handlePageClick,
    handleGoBack,
    handleToggleFullscreen
}) {
    const { setFullWidth } = useScreen();

    useEffect(() => {
        setFullWidth(true);
        return () => setFullWidth(false);
    }, [setFullWidth]);

    return (
        <div ref={fullscreenRef} className="material-view-wrapper">
            <div className={`material-view-page pb-0 ${isFullscreen ? 'fullscreen-mode' : ''}`}>
                {!(!loading && !material?.can_access) && (
                    <div className="material-layout">
                        <>
                            <PDFSidebar
                                pdf={pdfDocument}
                                currentPage={currentPage}
                                onPageClick={handlePageClick}
                                loading={loading || !pdfDocument}
                            />
                            <div className="material-container pb-6">
                                <PDFRender
                                    pdf={pdfDocument}
                                    zoom={zoom}
                                    onPageInView={setCurrentPage}
                                    loading={loading || !pdfDocument}
                                />
                            </div>
                        </>
                    </div>
                )}

                {!loading && !material?.can_access && (
                    material?.availability?.available !== true ? (
                        <div className="material-restricted-access">
                            <div className="mt-9 mb-3 material-restricted-access__header">
                                <Text.h3 className="material-restricted-access__title mb-1" contrast={8}>
                                    Este material é restrito a assinantes
                                </Text.h3>
                                <Text.span contrast={5}>
                                    Para ter acesso a este material, você precisa assinar a um dos planos abaixo.
                                </Text.span>
                            </div>
                            <CommunityPlansAvailableTable
                                communityId={material?.community}
                                availability={material?.availability}
                            />
                        </div>
                    ) : (
                        <h4 className="mt-8">Você não tem acesso a este material</h4>
                    )
                )}

                {material?.can_access && (
                    <div className="material-footer">
                        <div className="material-footer__content">
                            <Text.h4 className="material-footer__title" title={material?.name || ''}>
                                {material?.name || ''}
                            </Text.h4>
                            <div className="material-actions">
                                <Button
                                    className="download-file-btn"
                                    variant="contained"
                                    size="small"
                                    color="overlay"
                                    startIcon={<ArrowBackIosRounded />}
                                    onClick={handleGoBack}
                                >
                                    Voltar
                                </Button>
                                <Divider orientation="vertical" flexItem className="mx-1" />
                                <Button
                                    className="download-file-btn"
                                    variant="contained"
                                    size="medium"
                                    color="overlay"
                                    icon={isFullscreen ? <FullscreenExitRounded /> : <FullscreenRounded />}
                                    onClick={handleToggleFullscreen}
                                />
                                {currentCommunity?.isAdmin() && (
                                    <Button
                                        className="download-file-btn"
                                        variant="contained"
                                        size="medium"
                                        color="overlay"
                                        startIcon={<EditRounded />}
                                        onClick={handleOpenEditMaterial}
                                    >
                                        Editar
                                    </Button>
                                )}
                                {(material?.allow_download !== false || currentCommunity?.isAdmin?.()) && (
                                    <Button
                                        className="download-file-btn"
                                        variant="contained"
                                        size="medium"
                                        startIcon={<DownloadRounded />}
                                        onClick={handleDownload}
                                    >
                                        Download
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                )}


                <ManageMaterialModal modalRef={REF_materialModal} />
            </div>
        </div>
    );
}
